import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, view = false, className = "" }) => (
  <span className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
    <motion.span
      className={`block will-change-transform ${className}`}
      initial={{ y: "115%" }}
      {...(view
        ? { whileInView: { y: "0%" }, viewport: { once: true, margin: "-60px" } }
        : { animate: { y: "0%" } })}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, eyebrow, title, className = "" }) => (
  <div className={className}>
    <div className="flex items-center gap-4">
      <FadeIn y={12}>
        <span className="font-sans text-xs tracking-[0.3em] text-[#1E3A8A]">{index}</span>
      </FadeIn>
      <motion.span
        className="h-px w-16 origin-left bg-[#1E3A8A]/50 sm:w-24"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, delay: 0.2, ease: EASE }}
      />
      <FadeIn y={12} delay={0.1}>
        <span className="font-sans text-xs uppercase tracking-[0.3em] text-[#1E3A8A]/70">{eyebrow}</span>
      </FadeIn>
    </div>
    <h2 className="mt-8 font-sans text-3xl leading-[1.15] tracking-tight text-[#0F172A] sm:text-4xl lg:text-5xl">
      <MaskedLine view delay={0.15}>
        {title}
      </MaskedLine>
    </h2>
  </div>
);

export const SpotlightImage = ({ src, alt, testId, className = "", aspect = "aspect-[4/5]" }) => (
  <div className={`relative ${className}`}>
    <div className="absolute -inset-8 rounded-full bg-[#1E3A8A]/10 blur-3xl animate-pulse-glow" aria-hidden="true" />
    <div className={`relative overflow-hidden rounded-2xl border border-[#1E3A8A]/25 ${aspect}`}>
      <img
        src={src}
        alt={alt}
        data-testid={testId}
        className="h-full w-full object-cover grayscale-[35%] sepia-[18%] contrast-[1.05] transition-transform duration-700 hover:scale-[1.03]"
        loading="lazy"
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#08080A]/70 via-transparent to-[#08080A]/20" />
      <div className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-inset ring-[#1E3A8A]/20" />
    </div>
  </div>
);
